<template>
    <v-form ref="form" >
        <v-row>
            <v-col>
                <v-text-field
                    label="Name"
                    v-model="form.name"
                    :rules="[isRequired]"
                    dense
                    outlined
                    hide-details="auto"
                >
                </v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-autocomplete
                    label="Supplier"
                    v-model="form.supplier_id"
                    :items="suppliers"
                    item-value="id"
                    item-text="display_name"
                    @update:search-input="searchSuppliers"
                    dense
                    outlined
                    hide-details="auto"
                >
                </v-autocomplete>
            </v-col>
        </v-row>
        <v-row> 
            <v-col>
                <v-text-field
                    label="Phone"
                    v-model="form.phone"
                    :rules="[isRequired, isNumeric]"
                    dense
                    outlined
                    hide-details="auto"
                >
                </v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-text-field
                    label="Email"
                    :rules="[isEmail]"
                    v-model="form.email"
                    dense
                    outlined
                    hide-details="auto"
                >
                </v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-text-field
                    label="Position"
                    :rules="[isRequired]"
                    v-model="form.position"
                    dense
                    outlined
                    hide-details="auto"
                >
                </v-text-field>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { isRequired, isEmail, isNumeric } from "./../../utils/validations";
export default {
    name: "SupplierContactForm",
    props: {
        value: Object
    },
    data() {
        return {
            id: null,
            loading: false,
            form: {
                name: "",
                supplier_id: null,
                phone: null,
                email: '',
                position: ""
            }
        }
    },
    computed: {
        ...mapGetters({
            suppliers: "purchase/supplier/list"
        })
    },
    methods: {
        isNumeric,
        isRequired,
        isEmail,
        validate() {
            return this.$refs.form.validate()
        },
        ...mapActions({
            searchSuppliers: "purchase/supplier/search"
        })

    },
    watch: {
        form: {
            deep: true,
            handler(form) {
                this.$emit("input", {...form})
            }
        }
    },
    mounted() {
        if(this.value) {
            this.form = {...this.form, ...this.value} 
        }
    },
}
</script>

<style>

</style>